export default {
    limpiarEstado
}


const ESTADOS_MX = [
  "Aguascalientes",
  "Baja California",
  "Baja California Sur",
  "Campeche",
  "Coahuila de Zaragoza",
  "Colima",
  "Chiapas",
  "Chihuahua",
  "Ciudad de México",
  "Durango",
  "Guanajuato",
  "Guerrero",
  "Hidalgo",
  "Jalisco",
  "México",
  "Michoacán de Ocampo",
  "Morelos",
  "Nayarit",
  "Nuevo León",
  "Oaxaca",
  "Puebla",
  "Querétaro",
  "Quintana Roo",
  "San Luis Potosí",
  "Sinaloa",
  "Sonora",
  "Tabasco",
  "Tamaulipas",
  "Tlaxcala",
  "Veracruz de Ignacio de la Llave",
  "Yucatán",
  "Zacatecas",
];

function normalizeText(value = "") {
  return String(value)
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // quita acentos
    .replace(/\./g, "")
    .replace(/\s+/g, " ");
}

const aliasEstados = {
  // CDMX
  "ciudad de mexico": "Ciudad de México",
  "cdmx": "Ciudad de México",
  "cd de mexico": "Ciudad de México",
  "cdm": "Ciudad de México",
  "mexico city": "Ciudad de México",

  // Estado de México
  "mexico": "México",
  "estado de mexico": "México",
  "edo mx": "México",
  "edo de mexico": "México",
  "mexico state": "México",
  "mex": "México",

  // Querétaro
  "queretaro": "Querétaro",
  "q": "Querétaro",

  // Yucatán
  "yucatan": "Yucatán",
  "merida": "Yucatán",

  // Michoacán
  "michoacan": "Michoacán de Ocampo",
  "michoacan de ocampo": "Michoacán de Ocampo",

  // Veracruz
  "veracruz": "Veracruz de Ignacio de la Llave",
  "veracruz de ignacio de la llave": "Veracruz de Ignacio de la Llave",

  // Coahuila
  "coahuila": "Coahuila de Zaragoza",
  "coahuila de zaragoza": "Coahuila de Zaragoza",

  // Nuevo León
  "nuevo leon": "Nuevo León",

  // San Luis Potosí
  "san luis potosi": "San Luis Potosí",
  "s l p": "San Luis Potosí",
  "slp": "San Luis Potosí",

  // Baja California Sur
  "bcs": "Baja California Sur",

  // Abreviaciones comunes
  "jal": "Jalisco",
  "jjalisco": "Jalisco",
  "roo": "Quintana Roo",

  // Errores comunes
  "tamalipas": "Tamaulipas",

  // Ciudades detectadas en tu data
  "guadalajara": "Jalisco",
  "tampico": "Tamaulipas",
};

const estadosNormalizados = new Map(
  ESTADOS_MX.map((estado) => [normalizeText(estado), estado])
);

function limpiarEstado(value) {
  const key = normalizeText(value);

  // Ignorar valores inválidos
  if (!key || key.includes("@")) {
    return null;
  }

  // Coincidencia exacta contra estados oficiales
  if (estadosNormalizados.has(key)) {
    return estadosNormalizados.get(key);
  }

  // Coincidencia por alias
  if (aliasEstados[key]) {
    return aliasEstados[key];
  }

  return null;
}
